import React from 'react';
import SideBarContent from './SideBarContent';
import { Route, Switch } from 'react-router-dom';
import menu from 'appConstants/Menu';

const SideBarNav = ({sidebarExpand}) => {
    const expand = sidebarExpand
    return (
      
        <Switch>
          <Route exact path="/" render={() => <SideBarContent menu={menu.main} expand={expand}/>} />
          
          <Route render={() => <SideBarContent menu={menu.main} expand={expand} />} />
        </Switch>
      
    );
}

export default SideBarNav;
